import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="mg-container">
      <div className="not-found mg-mt-5">
        <div className="mg-text-center">
          <h2>{t("notFound.title")}</h2>
          <p>{t("notFound.message")}</p>
          <Link to="/songs" className="">
            {t("notFound.goToSongs")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
